import { DefaultTemplate, COR, CORES_SIM_NAO, CORES_PRIORIDADE } from './types';

// ============================================================
// COMPRAS & SUPRIMENTOS — Requisição de Compra, Homologação de
// Fornecedor, Contratos de Fornecimento
// ============================================================

const requisicaoCompra: DefaultTemplate = {
  id: 'tpl_compras',
  name: 'Requisição de Compra',
  descricao: 'Da necessidade ao recebimento: requisição, três cotações comparadas lado a lado, aprovação por alçada, emissão do pedido e conferência na entrega. Com SLA e devolução automática quando reprovado.',
  categoria: 'compras',
  icone: '🛒',
  etiquetas: [
    { nome: 'Urgente', cor: COR.vermelho },
    { nome: 'Investimento', cor: COR.roxo },
    { nome: 'Estoque', cor: COR.azul },
    { nome: 'Serviço', cor: COR.ciano },
  ],
  etapas: [
    {
      id: 'cm_e1', nome: 'Requisição',
      tempoMaximoHoras: 8,
      camposVisiveisNoCard: ['cm_c1', 'cm_c4', 'cm_c5'],
      permiteMoverPara: ['cm_e2'],
      campos: [
        { id: 'cm_c1', nome: 'Item / Serviço', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'cm_c2', nome: 'Especificação Técnica', tipo: 'texto_longo', obrigatorio: true },
        { id: 'cm_c3', nome: 'Quantidade', tipo: 'numero', obrigatorio: true },
        { id: 'cm_c4', nome: 'Setor Solicitante', tipo: 'lista', obrigatorio: true, opcoes: ['Administrativo', 'Comercial', 'Operações', 'TI', 'Marketing', 'RH', 'Manutenção'] },
        { id: 'cm_c5', nome: 'Prioridade', tipo: 'lista', obrigatorio: true, opcoes: ['Baixa', 'Média', 'Alta', 'Urgente'], coresOpcoes: CORES_PRIORIDADE },
        { id: 'cm_c6', nome: 'Justificativa da Necessidade', tipo: 'texto_longo', obrigatorio: true },
        { id: 'cm_c7', nome: 'Data Desejada', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'cm_c8', nome: 'Tipo', tipo: 'lista', obrigatorio: true, opcoes: ['Material de consumo', 'Ativo imobilizado', 'Serviço', 'Reposição de estoque'], coresOpcoes: { 'Ativo imobilizado': COR.roxo, 'Serviço': COR.ciano, 'Reposição de estoque': COR.azul } },
      ],
    },
    {
      id: 'cm_e2', nome: 'Cotação',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['cm_c1', 'cm_c15'],
      permiteMoverPara: ['cm_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'cm_c9', nome: 'Fornecedor 1', tipo: 'texto', obrigatorio: true },
        { id: 'cm_c10', nome: 'Valor 1', tipo: 'valor', obrigatorio: true },
        { id: 'cm_c11', nome: 'Fornecedor 2', tipo: 'texto', obrigatorio: false },
        { id: 'cm_c12', nome: 'Valor 2', tipo: 'valor', obrigatorio: false },
        { id: 'cm_c13', nome: 'Fornecedor 3', tipo: 'texto', obrigatorio: false },
        { id: 'cm_c14', nome: 'Valor 3', tipo: 'valor', obrigatorio: false },
        { id: 'cm_c15', nome: 'Fornecedor Recomendado', tipo: 'texto', obrigatorio: true },
        { id: 'cm_c16', nome: 'Valor Final', tipo: 'valor', obrigatorio: true },
        { id: 'cm_c17', nome: 'Justificativa da Escolha', tipo: 'texto_longo', obrigatorio: true },
        { id: 'cm_c18', nome: 'Propostas Anexadas', tipo: 'anexo', obrigatorio: false },
        { id: 'cm_c19', nome: 'Prazo de Entrega Prometido', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'cm_e3', nome: 'Aprovação',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['cm_c1', 'cm_c16', 'cm_c20'],
      permiteMoverPara: ['cm_e4', 'cm_e7'],
      limparCamposAoRetornar: ['cm_c20', 'cm_c21'],
      permiteCriarCards: false,
      campos: [
        { id: 'cm_c20', nome: 'Aprovado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'cm_c21', nome: 'Parecer do Aprovador', tipo: 'texto_longo', obrigatorio: false },
        { id: 'cm_c22', nome: 'Centro de Custo', tipo: 'lista', obrigatorio: false, opcoes: ['Administrativo', 'Comercial', 'Operações', 'TI', 'Marketing', 'RH'] },
      ],
    },
    {
      id: 'cm_e4', nome: 'Pedido Emitido',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['cm_c1', 'cm_c23', 'cm_c25'],
      permiteMoverPara: ['cm_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'cm_c23', nome: 'Nº do Pedido de Compra', tipo: 'texto', obrigatorio: true },
        { id: 'cm_c24', nome: 'Data de Emissão', tipo: 'data', obrigatorio: true },
        { id: 'cm_c25', nome: 'Previsão de Entrega', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'cm_c26', nome: 'Condição de Pagamento', tipo: 'lista', obrigatorio: false, opcoes: ['À vista', '15 dias', '28 dias', '30/60', '30/60/90'] },
        { id: 'cm_c27', nome: 'Pedido Assinado', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'cm_e5', nome: 'Recebimento',
      tempoMaximoHoras: 24,
      ordenacaoCards: 'vencimento_proximo',
      camposVisiveisNoCard: ['cm_c1', 'cm_c23', 'cm_c29'],
      permiteMoverPara: ['cm_e6', 'cm_e8'],
      permiteCriarCards: false,
      campos: [
        { id: 'cm_c28', nome: 'Data do Recebimento', tipo: 'data', obrigatorio: true },
        { id: 'cm_c29', nome: 'Conferido conforme pedido?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'cm_c30', nome: 'Nota Fiscal de Entrada', tipo: 'anexo', obrigatorio: true },
        { id: 'cm_c31', nome: 'Quantidade Recebida', tipo: 'numero', obrigatorio: false },
        { id: 'cm_c32', nome: 'Recebido por', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'cm_e6', nome: 'Concluído',
      camposVisiveisNoCard: ['cm_c1', 'cm_c16'],
      permiteCriarCards: false,
      campos: [
        { id: 'cm_c33', nome: 'Avaliação do Fornecedor', tipo: 'lista', obrigatorio: false, opcoes: ['Excelente', 'Bom', 'Regular', 'Ruim'], coresOpcoes: { 'Excelente': COR.verde, 'Bom': COR.ciano, 'Regular': COR.amarelo, 'Ruim': COR.vermelho } },
        { id: 'cm_c34', nome: 'Entregue no prazo?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'cm_e7', nome: 'Reprovado',
      camposVisiveisNoCard: ['cm_c1', 'cm_c35'],
      permiteMoverPara: ['cm_e1', 'cm_e2'],
      permiteCriarCards: false,
      campos: [
        { id: 'cm_c35', nome: 'Motivo da Reprovação', tipo: 'texto_longo', obrigatorio: true },
      ],
    },
    {
      id: 'cm_e8', nome: 'Pendência com Fornecedor',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['cm_c1', 'cm_c36'],
      permiteMoverPara: ['cm_e5', 'cm_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'cm_c36', nome: 'Tipo de Pendência', tipo: 'lista', obrigatorio: true, opcoes: ['Quantidade divergente', 'Item errado', 'Avaria', 'Atraso', 'Nota fiscal incorreta'], coresOpcoes: { 'Avaria': COR.vermelho, 'Atraso': COR.amarelo } },
        { id: 'cm_c37', nome: 'Descrição do Problema', tipo: 'texto_longo', obrigatorio: true },
        { id: 'cm_c38', nome: 'Foto / Evidência', tipo: 'anexo', obrigatorio: false },
        { id: 'cm_c39', nome: 'Resolvido?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Aprovado emite o pedido, reprovado volta ao solicitante',
      etapaOrigemId: 'cm_e3',
      condicao: { campoId: 'cm_c20', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'cm_e4',
      etapaDestinoSenaoId: 'cm_e7',
    },
    {
      tipo: 'mover',
      nome: 'Nº do pedido preenchido libera para recebimento',
      etapaOrigemId: 'cm_e4',
      condicao: { campoId: 'cm_c23', operador: 'preenchido' },
      etapaDestinoId: 'cm_e5',
    },
    {
      tipo: 'mover',
      nome: 'Conferência OK conclui, divergência abre pendência',
      etapaOrigemId: 'cm_e5',
      condicao: { campoId: 'cm_c29', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'cm_e6',
      etapaDestinoSenaoId: 'cm_e8',
    },
    {
      tipo: 'mover',
      nome: 'Pendência resolvida volta ao recebimento',
      etapaOrigemId: 'cm_e8',
      condicao: { campoId: 'cm_c39', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'cm_e6',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Mostrar parecer só quando reprovar',
      etapaOrigemId: 'cm_e3',
      condicao: { campoId: 'cm_c20', operador: 'igual', valor: 'Não' },
      camposAfetadosIds: ['cm_c21'],
    },
  ],
  cards: [
    { id: 'cm_card1', titulo: 'Notebooks para equipe comercial', etapaId: 'cm_e3', etiquetas: ['Investimento'], valores: { cm_c1: 'Notebooks para equipe comercial', cm_c3: 5, cm_c4: 'Comercial', cm_c5: 'Alta', cm_c8: 'Ativo imobilizado', cm_c15: 'Dell Brasil', cm_c16: 27500 } },
    { id: 'cm_card2', titulo: 'Material de escritório - trimestral', etapaId: 'cm_e2', etiquetas: ['Estoque'], valores: { cm_c1: 'Material de escritório - trimestral', cm_c3: 1, cm_c4: 'Administrativo', cm_c5: 'Baixa', cm_c8: 'Reposição de estoque' } },
    { id: 'cm_card3', titulo: 'Manutenção do ar-condicionado', etapaId: 'cm_e5', etiquetas: ['Serviço'], valores: { cm_c1: 'Manutenção do ar-condicionado', cm_c4: 'Manutenção', cm_c5: 'Média', cm_c8: 'Serviço', cm_c15: 'Clima Frio Ltda', cm_c16: 3400, cm_c23: 'PC-2026-0148' } },
    { id: 'cm_card4', titulo: 'Cadeiras ergonômicas', etapaId: 'cm_e8', valores: { cm_c1: 'Cadeiras ergonômicas', cm_c3: 12, cm_c4: 'RH', cm_c5: 'Média', cm_c8: 'Ativo imobilizado', cm_c36: 'Quantidade divergente', cm_c37: 'Chegaram 10 de 12 cadeiras.' } },
    { id: 'cm_card5', titulo: 'Uniformes da operação', etapaId: 'cm_e1', valores: { cm_c1: 'Uniformes da operação', cm_c3: 40, cm_c4: 'Operações', cm_c5: 'Média', cm_c8: 'Material de consumo' } },
    { id: 'cm_card6', titulo: 'Servidor de backup', etapaId: 'cm_e6', etiquetas: ['Investimento'], valores: { cm_c1: 'Servidor de backup', cm_c4: 'TI', cm_c5: 'Alta', cm_c8: 'Ativo imobilizado', cm_c16: 42000, cm_c33: 'Excelente', cm_c34: 'Sim' } },
    { id: 'cm_card7', titulo: 'Assinatura de software de design', etapaId: 'cm_e7', valores: { cm_c1: 'Assinatura de software de design', cm_c4: 'Marketing', cm_c5: 'Baixa', cm_c8: 'Serviço', cm_c35: 'Já existe licença ociosa disponível no time de TI.' } },
  ],
  tour: [
    '🛒 Compra sem improviso: requisição, cotação, alçada, pedido e conferência.',
    '1️⃣ "Requisição": quem precisa descreve o item, quantidade, prioridade e justificativa.',
    '2️⃣ "Cotação": três fornecedores lado a lado + justificativa da escolha (auditável).',
    '3️⃣ "Aprovação": aprovou vai para o pedido; reprovou volta ao solicitante com motivo.',
    '4️⃣ "Pedido Emitido": número do PC preenchido já libera o card para recebimento.',
    '5️⃣ "Recebimento": conferiu certo → Concluído. Deu problema → "Pendência com Fornecedor".',
    '📦 A pendência tem trilha própria: quantidade divergente, avaria, atraso, NF errada.',
    '⭐ No fim você avalia o fornecedor — histórico para a próxima cotação.',
  ],
  etapasDicas: [
    { quemFaz: 'Qualquer setor', objetivo: 'Registrar a necessidade com especificação clara — cotação ruim nasce de requisição vaga.', ondeConfigurar: 'Configuração da Etapa > Campos obrigatórios' },
    { quemFaz: 'Comprador / Suprimentos', objetivo: 'Levantar três propostas e justificar a escolha — proteção em auditoria.', automacoes: ['Use o módulo de Cotação do Escalone para pedir orçamento por e-mail direto do card'], ondeConfigurar: 'Configuração do Fluxo > Cotação' },
    { quemFaz: 'Gestor / Diretoria conforme alçada', objetivo: 'Autorizar o gasto com o comparativo de cotações à vista.', automacoes: ['Já configurado: aprovado emite pedido, reprovado volta ao solicitante', 'Já configurado: parecer só aparece quando reprova'], ondeConfigurar: 'Automações > "Aprovado emite o pedido..."' },
    { quemFaz: 'Comprador', objetivo: 'Formalizar o pedido com número, prazo e condição de pagamento.', conexoes: ['Ligue a Contas a Pagar: pedido emitido já provisiona o pagamento'], ondeConfigurar: 'Conexões entre Fluxos > Contas a Pagar' },
    { quemFaz: 'Almoxarifado / Recebedor', objetivo: 'Conferir o que chegou contra o pedido antes de aceitar a nota.', automacoes: ['Já configurado: conferência OK conclui, divergência abre pendência'], conexoes: ['Ligue a Controle de Estoque para dar entrada automática no material'], ondeConfigurar: 'Automações > "Conferência OK conclui..."' },
    { quemFaz: 'Suprimentos', objetivo: 'Fechar o ciclo avaliando o fornecedor — vira histórico para a próxima compra.', ondeConfigurar: 'Configuração da Etapa > Campos' },
    { quemFaz: 'Solicitante', objetivo: 'Entender a recusa e reformular a requisição, se ainda fizer sentido.', ondeConfigurar: 'Configuração da Etapa > Transições permitidas' },
    { quemFaz: 'Comprador', objetivo: 'Cobrar o fornecedor com evidência registrada até resolver.', automacoes: ['Já configurado: pendência resolvida devolve o card para o fluxo normal'], ondeConfigurar: 'Automações > "Pendência resolvida volta ao recebimento"' },
  ],
};

const homologacaoFornecedor: DefaultTemplate = {
  id: 'tpl_homologacao_fornecedor',
  name: 'Homologação de Fornecedor',
  descricao: 'Cadastre e qualifique fornecedores com documentação, análise de risco, verificação fiscal e aprovação final. Só compra de quem passou pelo crivo — e com data de revalidação.',
  categoria: 'compras',
  icone: '🤝',
  etiquetas: [
    { nome: 'Crítico', cor: COR.vermelho },
    { nome: 'Homologado', cor: COR.verde },
    { nome: 'Revalidar', cor: COR.amarelo },
  ],
  etapas: [
    {
      id: 'hf_e1', nome: 'Cadastro Inicial',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['hf_c1', 'hf_c4'],
      permiteMoverPara: ['hf_e2'],
      campos: [
        { id: 'hf_c1', nome: 'Razão Social', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'hf_c2', nome: 'CNPJ', tipo: 'texto', obrigatorio: true },
        { id: 'hf_c3', nome: 'Nome Fantasia', tipo: 'texto', obrigatorio: false },
        { id: 'hf_c4', nome: 'Categoria de Fornecimento', tipo: 'lista', obrigatorio: true, opcoes: ['Matéria-prima', 'Serviços', 'Equipamentos', 'Transporte / Logística', 'TI', 'Facilities', 'Consultoria'] },
        { id: 'hf_c5', nome: 'Contato Comercial', tipo: 'texto', obrigatorio: true },
        { id: 'hf_c6', nome: 'Telefone', tipo: 'telefone', obrigatorio: false },
        { id: 'hf_c7', nome: 'E-mail', tipo: 'texto', obrigatorio: false },
        { id: 'hf_c8', nome: 'Indicado por', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'hf_e2', nome: 'Documentação',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['hf_c1', 'hf_c9'],
      permiteMoverPara: ['hf_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'hf_c9', nome: 'Documentos Recebidos', tipo: 'checkbox_multi', obrigatorio: true, opcoes: ['Contrato social', 'Cartão CNPJ', 'Certidão federal', 'Certidão estadual', 'Certidão municipal', 'FGTS', 'Trabalhista', 'Dados bancários'] },
        { id: 'hf_c10', nome: 'Pasta de Documentos', tipo: 'anexo', obrigatorio: false },
        { id: 'hf_c11', nome: 'Documentação completa?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'hf_e3', nome: 'Análise Fiscal e Jurídica',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['hf_c1', 'hf_c13'],
      permiteMoverPara: ['hf_e4', 'hf_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'hf_c12', nome: 'Certidões válidas?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'hf_c13', nome: 'Risco Identificado', tipo: 'lista', obrigatorio: true, opcoes: ['Baixo', 'Médio', 'Alto'], coresOpcoes: { 'Baixo': COR.verde, 'Médio': COR.amarelo, 'Alto': COR.vermelho } },
        { id: 'hf_c14', nome: 'Apontamentos', tipo: 'texto_longo', obrigatorio: false },
        { id: 'hf_c15', nome: 'Regime Tributário', tipo: 'lista', obrigatorio: false, opcoes: ['Simples Nacional', 'Lucro Presumido', 'Lucro Real', 'MEI'] },
      ],
    },
    {
      id: 'hf_e4', nome: 'Avaliação Técnica',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['hf_c1', 'hf_c17'],
      permiteMoverPara: ['hf_e5', 'hf_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'hf_c16', nome: 'Visita / Auditoria realizada?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'hf_c17', nome: 'Nota Técnica (0-10)', tipo: 'numero', obrigatorio: true, valorMinimo: 0, valorMaximo: 10 },
        { id: 'hf_c18', nome: 'Capacidade de Atendimento', tipo: 'texto_longo', obrigatorio: false },
        { id: 'hf_c19', nome: 'Certificações do Fornecedor', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['ISO 9001', 'ISO 14001', 'ISO 45001', 'Nenhuma'] },
      ],
    },
    {
      id: 'hf_e5', nome: 'Homologado',
      camposVisiveisNoCard: ['hf_c1', 'hf_c4', 'hf_c21'],
      permiteMoverPara: ['hf_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'hf_c20', nome: 'Data da Homologação', tipo: 'data', obrigatorio: true },
        { id: 'hf_c21', nome: 'Válido até', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'hf_c22', nome: 'Condições Comerciais Negociadas', tipo: 'texto_longo', obrigatorio: false },
        { id: 'hf_c23', nome: 'Código no ERP', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'hf_e6', nome: 'Reprovado / Bloqueado',
      camposVisiveisNoCard: ['hf_c1', 'hf_c24'],
      permiteMoverPara: ['hf_e2'],
      permiteCriarCards: false,
      campos: [
        { id: 'hf_c24', nome: 'Motivo', tipo: 'texto_longo', obrigatorio: true },
        { id: 'hf_c25', nome: 'Pode ser reavaliado?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Documentação completa segue para análise',
      etapaOrigemId: 'hf_e2',
      condicao: { campoId: 'hf_c11', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'hf_e3',
    },
    {
      tipo: 'mover',
      nome: 'Certidões inválidas bloqueiam o fornecedor',
      etapaOrigemId: 'hf_e3',
      condicao: { campoId: 'hf_c12', operador: 'igual', valor: 'Não' },
      etapaDestinoId: 'hf_e6',
      etapaDestinoSenaoId: 'hf_e4',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Mostrar apontamentos quando o risco for alto',
      etapaOrigemId: 'hf_e3',
      condicao: { campoId: 'hf_c13', operador: 'igual', valor: 'Alto' },
      camposAfetadosIds: ['hf_c14'],
    },
  ],
  cards: [
    { id: 'hf_card1', titulo: 'Metalúrgica Souza Ltda', etapaId: 'hf_e5', etiquetas: ['Homologado'], valores: { hf_c1: 'Metalúrgica Souza Ltda', hf_c4: 'Matéria-prima', hf_c13: 'Baixo', hf_c17: 9 } },
    { id: 'hf_card2', titulo: 'TransLog Transportes', etapaId: 'hf_e4', etiquetas: ['Crítico'], valores: { hf_c1: 'TransLog Transportes', hf_c4: 'Transporte / Logística', hf_c13: 'Médio', hf_c17: 7 } },
    { id: 'hf_card3', titulo: 'Consultoria Prisma', etapaId: 'hf_e3', valores: { hf_c1: 'Consultoria Prisma', hf_c4: 'Consultoria', hf_c13: 'Baixo' } },
    { id: 'hf_card4', titulo: 'Info Peças Comércio', etapaId: 'hf_e2', valores: { hf_c1: 'Info Peças Comércio', hf_c4: 'TI' } },
    { id: 'hf_card5', titulo: 'Serviços Rápidos ME', etapaId: 'hf_e6', valores: { hf_c1: 'Serviços Rápidos ME', hf_c4: 'Facilities', hf_c24: 'Certidão trabalhista negativa vencida e sem regularização em 60 dias.', hf_c25: 'Sim' } },
    { id: 'hf_card6', titulo: 'Distribuidora Central', etapaId: 'hf_e5', etiquetas: ['Homologado', 'Revalidar'], valores: { hf_c1: 'Distribuidora Central', hf_c4: 'Equipamentos', hf_c13: 'Baixo', hf_c17: 8 } },
  ],
  tour: [
    '🤝 Fornecedor só entra na base depois de passar por aqui.',
    '1️⃣ "Cadastro Inicial": dados básicos e categoria de fornecimento.',
    '2️⃣ "Documentação": checklist de certidões e contrato social. Completo? o card anda sozinho.',
    '3️⃣ "Análise Fiscal e Jurídica": certidão inválida bloqueia automaticamente.',
    '4️⃣ "Avaliação Técnica": nota de 0 a 10, visita e certificações.',
    '5️⃣ "Homologado" com data de validade — quando vencer, revalide.',
    '🚩 O campo Apontamentos só aparece quando o risco é Alto.',
  ],
  etapasDicas: [
    { quemFaz: 'Suprimentos', objetivo: 'Abrir a ficha do fornecedor com dados de contato e categoria.', ondeConfigurar: 'Configuração da Etapa > Campos' },
    { quemFaz: 'Suprimentos / Administrativo', objetivo: 'Reunir a documentação obrigatória antes de qualquer análise.', automacoes: ['Já configurado: documentação completa avança para análise'], ondeConfigurar: 'Automações > "Documentação completa segue para análise"' },
    { quemFaz: 'Fiscal + Jurídico', objetivo: 'Validar certidões e classificar o risco do fornecedor.', automacoes: ['Já configurado: certidão inválida bloqueia', 'Já configurado: apontamentos aparecem quando risco = Alto'], conexoes: ['Ligue a Processos Jurídicos quando houver litígio conhecido'], ondeConfigurar: 'Automações > "Certidões inválidas bloqueiam o fornecedor"' },
    { quemFaz: 'Área técnica que vai usar o fornecedor', objetivo: 'Avaliar capacidade real de atendimento antes de homologar.', ondeConfigurar: 'Configuração da Etapa > Campos' },
    { quemFaz: 'Gerente de Suprimentos', objetivo: 'Liberar o fornecedor com validade definida e condições negociadas.', automacoes: ['Ative alerta de vencimento no campo "Válido até" para revalidar a tempo'], conexoes: ['Ligue a Requisição de Compra: só cotar com fornecedor homologado'], ondeConfigurar: 'Configuração da Etapa > Alerta de vencimento' },
    { quemFaz: 'Suprimentos', objetivo: 'Registrar o bloqueio com motivo — evita recompra do mesmo problema.', ondeConfigurar: 'Configuração da Etapa > Campos' },
  ],
};

const contratosFornecimento: DefaultTemplate = {
  id: 'tpl_contratos_fornecimento',
  name: 'Contratos de Fornecimento',
  descricao: 'Ciclo de vida do contrato com fornecedor: minuta, negociação, aprovação jurídica, assinatura e controle de vigência com aviso de renovação. Nunca mais deixe contrato vencer no silêncio.',
  categoria: 'compras',
  icone: '📑',
  etiquetas: [
    { nome: 'Renovação automática', cor: COR.azul },
    { nome: 'Vence em 90 dias', cor: COR.amarelo },
    { nome: 'Estratégico', cor: COR.roxo },
  ],
  etapas: [
    {
      id: 'cf_e1', nome: 'Demanda de Contrato',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['cf_c1', 'cf_c3', 'cf_c4'],
      permiteMoverPara: ['cf_e2'],
      campos: [
        { id: 'cf_c1', nome: 'Objeto do Contrato', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'cf_c2', nome: 'Fornecedor', tipo: 'texto', obrigatorio: true },
        { id: 'cf_c3', nome: 'Valor Mensal / Global', tipo: 'valor', obrigatorio: true },
        { id: 'cf_c4', nome: 'Tipo de Contrato', tipo: 'lista', obrigatorio: true, opcoes: ['Fornecimento contínuo', 'Prestação de serviço', 'Locação', 'Manutenção', 'Licenciamento'], coresOpcoes: { 'Locação': COR.roxo, 'Manutenção': COR.ciano } },
        { id: 'cf_c5', nome: 'Área Demandante', tipo: 'lista', obrigatorio: true, opcoes: ['Administrativo', 'Comercial', 'Operações', 'TI', 'Marketing', 'RH', 'Manutenção'] },
        { id: 'cf_c6', nome: 'Escopo Resumido', tipo: 'texto_longo', obrigatorio: true },
      ],
    },
    {
      id: 'cf_e2', nome: 'Minuta e Negociação',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['cf_c1', 'cf_c2'],
      permiteMoverPara: ['cf_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'cf_c7', nome: 'Minuta', tipo: 'anexo', obrigatorio: true },
        { id: 'cf_c8', nome: 'Pontos em Negociação', tipo: 'texto_longo', obrigatorio: false },
        { id: 'cf_c9', nome: 'Reajuste', tipo: 'lista', obrigatorio: false, opcoes: ['IPCA anual', 'IGP-M anual', 'Sem reajuste', 'A negociar'] },
        { id: 'cf_c10', nome: 'Multa por Rescisão', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'cf_e3', nome: 'Análise Jurídica',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['cf_c1', 'cf_c11'],
      permiteMoverPara: ['cf_e4', 'cf_e2'],
      permiteCriarCards: false,
      campos: [
        { id: 'cf_c11', nome: 'Parecer Jurídico', tipo: 'lista', obrigatorio: true, opcoes: ['Aprovado', 'Aprovado com ressalvas', 'Reprovado'], coresOpcoes: { 'Aprovado': COR.verde, 'Aprovado com ressalvas': COR.amarelo, 'Reprovado': COR.vermelho } },
        { id: 'cf_c12', nome: 'Ressalvas / Ajustes Necessários', tipo: 'texto_longo', obrigatorio: false },
        { id: 'cf_c13', nome: 'Cláusulas de Risco Sinalizadas', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'cf_e4', nome: 'Assinatura',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['cf_c1', 'cf_c14'],
      permiteMoverPara: ['cf_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'cf_c14', nome: 'Status da Assinatura', tipo: 'lista', obrigatorio: true, opcoes: ['Aguardando fornecedor', 'Aguardando diretoria', 'Assinado'], coresOpcoes: { 'Assinado': COR.verde, 'Aguardando fornecedor': COR.amarelo } },
        { id: 'cf_c15', nome: 'Contrato Assinado', tipo: 'anexo', obrigatorio: false },
        { id: 'cf_c16', nome: 'Data da Assinatura', tipo: 'data', obrigatorio: false },
      ],
    },
    {
      id: 'cf_e5', nome: 'Vigente',
      ordenacaoCards: 'vencimento_proximo',
      camposVisiveisNoCard: ['cf_c1', 'cf_c3', 'cf_c18'],
      permiteMoverPara: ['cf_e6', 'cf_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'cf_c17', nome: 'Início da Vigência', tipo: 'data', obrigatorio: true },
        { id: 'cf_c18', nome: 'Fim da Vigência', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'cf_c19', nome: 'Renovação automática?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'cf_c20', nome: 'Aviso Prévio (dias)', tipo: 'numero', obrigatorio: false },
        { id: 'cf_c21', nome: 'Gestor do Contrato', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'cf_e6', nome: 'Em Renovação',
      tempoMaximoHoras: 240,
      camposVisiveisNoCard: ['cf_c1', 'cf_c18'],
      permiteMoverPara: ['cf_e5', 'cf_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'cf_c22', nome: 'Proposta de Renovação', tipo: 'texto_longo', obrigatorio: true },
        { id: 'cf_c23', nome: 'Novo Valor', tipo: 'valor', obrigatorio: false },
        { id: 'cf_c24', nome: 'Renovar?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'cf_e7', nome: 'Encerrado',
      camposVisiveisNoCard: ['cf_c1', 'cf_c25'],
      permiteCriarCards: false,
      campos: [
        { id: 'cf_c25', nome: 'Motivo do Encerramento', tipo: 'lista', obrigatorio: true, opcoes: ['Fim da vigência', 'Rescisão amigável', 'Rescisão por descumprimento', 'Troca de fornecedor'] },
        { id: 'cf_c26', nome: 'Observações Finais', tipo: 'texto_longo', obrigatorio: false },
        { id: 'cf_c27', nome: 'Distrato', tipo: 'anexo', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Jurídico reprovou volta para negociação',
      etapaOrigemId: 'cf_e3',
      condicao: { campoId: 'cf_c11', operador: 'igual', valor: 'Reprovado' },
      etapaDestinoId: 'cf_e2',
      etapaDestinoSenaoId: 'cf_e4',
    },
    {
      tipo: 'mover',
      nome: 'Contrato assinado entra em vigência',
      etapaOrigemId: 'cf_e4',
      condicao: { campoId: 'cf_c14', operador: 'igual', valor: 'Assinado' },
      etapaDestinoId: 'cf_e5',
    },
    {
      tipo: 'mover',
      nome: 'Renovação aprovada devolve o contrato à vigência',
      etapaOrigemId: 'cf_e6',
      condicao: { campoId: 'cf_c24', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'cf_e5',
      etapaDestinoSenaoId: 'cf_e7',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Mostrar ressalvas quando houver',
      etapaOrigemId: 'cf_e3',
      condicao: { campoId: 'cf_c11', operador: 'igual', valor: 'Aprovado com ressalvas' },
      camposAfetadosIds: ['cf_c12'],
    },
  ],
  cards: [
    { id: 'cf_card1', titulo: 'Locação da sede administrativa', etapaId: 'cf_e5', etiquetas: ['Estratégico', 'Renovação automática'], valores: { cf_c1: 'Locação da sede administrativa', cf_c2: 'Imobiliária Central', cf_c3: 4500, cf_c4: 'Locação', cf_c5: 'Administrativo', cf_c19: 'Sim' } },
    { id: 'cf_card2', titulo: 'Manutenção predial preventiva', etapaId: 'cf_e5', etiquetas: ['Vence em 90 dias'], valores: { cf_c1: 'Manutenção predial preventiva', cf_c2: 'Predial Serviços', cf_c3: 2800, cf_c4: 'Manutenção', cf_c5: 'Manutenção' } },
    { id: 'cf_card3', titulo: 'Licenciamento ERP corporativo', etapaId: 'cf_e6', etiquetas: ['Estratégico'], valores: { cf_c1: 'Licenciamento ERP corporativo', cf_c2: 'Sistemas Integra', cf_c3: 12500, cf_c4: 'Licenciamento', cf_c5: 'TI', cf_c22: 'Fornecedor propôs reajuste de 8%; contraproposta em 4%.' } },
    { id: 'cf_card4', titulo: 'Transporte de mercadorias', etapaId: 'cf_e3', valores: { cf_c1: 'Transporte de mercadorias', cf_c2: 'TransLog Transportes', cf_c3: 18000, cf_c4: 'Prestação de serviço', cf_c5: 'Operações', cf_c11: 'Aprovado com ressalvas', cf_c12: 'Ajustar cláusula de responsabilidade por avaria.' } },
    { id: 'cf_card5', titulo: 'Fornecimento de embalagens', etapaId: 'cf_e1', valores: { cf_c1: 'Fornecimento de embalagens', cf_c2: 'Embalagens Prima', cf_c3: 9200, cf_c4: 'Fornecimento contínuo', cf_c5: 'Operações' } },
    { id: 'cf_card6', titulo: 'Consultoria tributária (encerrado)', etapaId: 'cf_e7', valores: { cf_c1: 'Consultoria tributária', cf_c2: 'Prisma Consultoria', cf_c3: 6000, cf_c4: 'Prestação de serviço', cf_c5: 'Administrativo', cf_c25: 'Fim da vigência' } },
  ],
  tour: [
    '📑 Todo contrato com fornecedor, do nascimento ao encerramento.',
    '1️⃣ "Demanda": a área diz o que precisa contratar e por quanto.',
    '2️⃣ "Minuta e Negociação": reajuste, multa e pontos em aberto.',
    '3️⃣ "Análise Jurídica": reprovou volta para negociação automaticamente.',
    '4️⃣ "Assinatura": marcou "Assinado", o contrato entra em vigência sozinho.',
    '5️⃣ "Vigente": coluna ordenada por vencimento — o que vence antes aparece primeiro.',
    '🔄 "Em Renovação": renovou? volta para Vigente. Não renovou? vai para Encerrado.',
    '💡 Configure alerta no campo "Fim da Vigência" e nunca mais perca prazo de aviso prévio.',
  ],
  etapasDicas: [
    { quemFaz: 'Área demandante', objetivo: 'Formalizar a necessidade de contrato com escopo e valor estimado.', ondeConfigurar: 'Configuração da Etapa > Campos' },
    { quemFaz: 'Suprimentos', objetivo: 'Negociar condições comerciais antes de acionar o jurídico.', ondeConfigurar: 'Configuração da Etapa > Campos' },
    { quemFaz: 'Jurídico', objetivo: 'Analisar risco contratual e apontar cláusulas problemáticas.', automacoes: ['Já configurado: reprovado volta para negociação', 'Já configurado: ressalvas aparecem só quando existem'], ondeConfigurar: 'Automações > "Jurídico reprovou volta para negociação"' },
    { quemFaz: 'Diretoria + Fornecedor', objetivo: 'Coletar assinaturas e arquivar a via final.', automacoes: ['Já configurado: status "Assinado" coloca o contrato em vigência'], ondeConfigurar: 'Automações > "Contrato assinado entra em vigência"' },
    { quemFaz: 'Gestor do contrato', objetivo: 'Acompanhar vigência e agir antes do prazo de aviso prévio.', automacoes: ['Ative o alerta de vencimento para receber aviso com antecedência'], conexoes: ['Ligue a Contas a Pagar para gerar a parcela mensal do contrato'], ondeConfigurar: 'Configuração da Etapa > Alerta de vencimento' },
    { quemFaz: 'Suprimentos + Gestor', objetivo: 'Decidir renovação com base em desempenho e preço de mercado.', automacoes: ['Já configurado: renovar = Sim volta para Vigente; Não vai para Encerrado'], ondeConfigurar: 'Automações > "Renovação aprovada devolve o contrato à vigência"' },
    { quemFaz: 'Suprimentos + Jurídico', objetivo: 'Encerrar formalmente com distrato e histórico do motivo.', ondeConfigurar: 'Configuração da Etapa > Campos' },
  ],
};

export const TEMPLATES_COMPRAS: DefaultTemplate[] = [
  requisicaoCompra,
  homologacaoFornecedor,
  contratosFornecimento,
];
